<button *ngIf="getSortIcon(column) as icon" (click)="handleSortClick(column)" class="sort-button {{{'arrow_drop_up': 'asc', 'arrow_drop_down': 'desc', 'unfold_more': ''}[icon]}}" style="line-height: 1;">
    <mat-icon>{{ icon }}</mat-icon>
</button>
